import _ from '@sparta.global.vendors/lodash';
import $ from '@sparta.global.vendors/jquery';
import hbs from '@sparta.global.vendors/handlebars';

var index = {
  /**
   * @return {void}
   */
  disableModule() {
    this.$target.addClass('hide');
  },
  /**
   * @return {void}
   */
  enableModule() {
    this.$target.removeClass('hide');
  },
  /**
   * @return {void}
   */
  fadeOutModule() {
    // fade out
    this.$target.fadeOut(1000);

    // add class
    this.$target.removeClass('todo-active');
  },
  /**
   * @method formatPrice
   * @param  {Number} amountBorrowed amount
   * @return {Object} dollarFormat
   */
  formatPrice(amountBorrowed) {
    // get amount
    // eslint-disable-next-line no-var
    var dollarFormat = amountBorrowed.toString().split('.');

    // if length is greater than 5
    if (dollarFormat[0].length >= 5) {
      dollarFormat[0] = dollarFormat[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    }

    // if length is greater than 5
    if (dollarFormat[1] && dollarFormat[1].length >= 5) {
      dollarFormat[1] = dollarFormat[1].replace(/(\d{3})/g, '$1 ');
    }

    // return dollar format
    return dollarFormat.join('.');
  },
  formatZip(zipCode) {
    // if undefined show empty string
    if (zipCode === undefined) {
      // eslint-disable-next-line no-param-reassign
      zipCode = '';
    }

    // strip anything but the 5 values for zip
    var zipFormat = zipCode.slice(0, 5);

    // strip anything but characters, and leave numbers
    return zipFormat.replace(/[^0-9]/g, '');
  },
  bindAllMethod() {
    // lets get modules prototype
    let methods = Object.getOwnPropertyNames(Object.getPrototypeOf(this));

    // bind all methods with this
    let loopThroughMethods = method => {
      this[method] = this[method].bind(this);
    };

    // remove init & constructor methods
    methods = methods.slice(1, -1);

    // loop through methods
    methods.forEach(loopThroughMethods);
  },
  dropdownToggle($dropdown, $arrow) {
    return () => {
      // slide Toggle of dropdown Contact-us menu
      $dropdown.slideToggle('slow');

      // toggle class of rotate, so that chevron rotates correct direction
      $arrow.toggleClass('rotate-up rotate-down');
    };
  },
  getQueryParamValues(url) {
    // eslint-disable-next-line no-useless-escape
    const pattern = /([^\/\?\&\=]+\=[^\&\#]+)/g;
    const matches = url.match(pattern);
    return matches && _.fromPairs(matches.map(pair => pair.split('=').map(encodeURIComponent)));
  },
  /**
  * @method inputRemovePatternDataAttr
  * @param selector object
  * @desc - removes input data-default-pattern and pattern attributes and adds a
  * match on anything that fixes a parsley issue with sparta inputs >=v5
  * @return {void}
  */
  inputRemovePatternDataAttr(selector) {
    // eslint-disable-next-line prefer-const
    let $selector = $(selector);
    // eslint-disable-next-line prefer-arrow-callback
    $selector.find('input').each(function f1(idx, val) {
      // eslint-disable-next-line prefer-const
      let $val = $(val);
      $val.removeAttr('data-default-pattern').attr('data-default-pattern', '.*').removeAttr('pattern');
    });
  },
  // eslint-disable-next-line consistent-return
  updatePartial(state, partialId, elementClass, helpers = null) {
    // cache selector
    const $partial = $(partialId);

    // partial doesn't exist stop updating
    if (!$partial.length) {
      return false;
    }

    // cache html inside of selector
    const html = $partial.html();
    if (helpers) {
      // eslint-disable-next-line no-restricted-syntax, prefer-const
      for (let helper in helpers) {
        // eslint-disable-next-line no-prototype-builtins
        if (helpers.hasOwnProperty(helper)) {
          hbs.registerHelper(helper, helpers[helper]);
        }
      }
    }

    // create handlebars template
    const hbsTemplate = hbs.compile(html);

    // cache template
    const source = hbsTemplate(state);

    // add hbs to dom
    $(elementClass).html(source);
  },
  spartaInputHack($target) {
    const fix = () => {
      $target.find('.spa-input').each(function f2() {
        const $duplicateDropdowns = $(this).siblings('.input-help:not(:first)');
        $duplicateDropdowns.remove();
        const $duplicateTriggers = $(this).children('.toggle-trigger:not(:last)');
        $duplicateTriggers.remove();
      });
    };
    setTimeout(fix, 2000);
  },
  /**
   * @method toTitleCase
   * @param {String} words - a string to convert to title client-name-secure-home-loans
   * @desc convert a string to title case
   * @return {void}
   */
  toTitleCase(words) {
    return words.split(' ').map(word => word.slice(0, 1).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
  },
  /**
   * @method caseWord
   * @param {String} str string
   * @return {void}
   */
  caseWord(str) {
    return str.replace(/\w\S*/g, function func1(txt) {
      return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
    });
  },
  /**
   * @method replaceTokens
   * @param {Object} $element - the element to search for tokens
   * @param {Object} context - an object containing the replacement values
   * @return {void}
   * @desc replace token values with dynamic data
   */
  replaceTokens($element, context) {
    const traverseTo = (o, path) => {
      return _.reduce(path, (memo, segment) => memo && memo[segment], o);
    };
    const formatValue = (value, type = 'string') => {
      switch (type) {
        case 'currency':
          // eslint-disable-next-line no-case-declarations, no-new-wrappers
          const formatted = value && new Number(value).toLocaleString();
          // eslint-disable-next-line no-useless-escape
          return `\$${formatted || 'XXX,XXX'}`;
        case 'date':
          // @todo: format date values
          return value ? value : new Date().toLocaleDateString();
        case 'percentage':
          // eslint-disable-next-line no-new-wrappers
          return `${value ? new Number(value).toFixed(3) : 'X.XXX'}%`;
        case 'zipcode':
          return value ? value.slice(0, 5) : 'XXXXX';
        default:
          return value;
      }
    };
    const $tokens = $element.find('.convert');
    $tokens.each(function f4() {
      const $token = $(this);
      const key = $token.data('token');
      if (key) {
        const value = traverseTo(context, key.split('.'));
        const formatted = formatValue(value, $token.data('type'));
        if (formatted || formatted === 0) {
          $token.html(formatted);
        }
      }
    });
  },
  /**
   * @method registerHandlebarsHelpers
   * @param {Handlebars} handlebars - an instance of handlebars
   * @param {Object} helpers - an object with methods that follow the handlebars helper convention
   * @return {void}
   * @desc register helpers with an instance of handlebars
   */
  registerHandlebarsHelpers(handlebars, helpers) {
    // eslint-disable-next-line keyword-spacing, no-restricted-syntax, vars-on-top, no-var
    for (var helper in helpers) {
      // eslint-disable-next-line no-prototype-builtins
      if (helpers.hasOwnProperty(helper)) {
        handlebars.registerHelper(helper, helpers[helper]);
      }
    }
  },
  render($elements, context, handlebars, renderedList) {
    $elements.each(function f8() {
      const $instance = $(this);
      const id = $instance.attr('id');
      if (!renderedList[id]) {
        renderedList[id] = true;
        const template = $instance.html();
        const templateFunction = handlebars.compile(template);
        const html = templateFunction(context);
        $instance.html(html);
      }
    });
  },
  toggleContent($elements, condition) {
    if (condition) {
      $elements.show();
    } else {
      $elements.hide();
    }
  },
  /**
   * this is a real douzie of functional composition
   * give it a list of strings ('.some-class','#someId', jQuery elements or both
   * the first arg can optionally be 'show' or 'hide' all elems
   * depending on what you want to do.  Default, it will .toggle()
   * bonus: if you give it 'hideandclear' and it will clean inputs after that
   * it can handle elements that have either a declared visibility,
   * display or opacity and toggle it properly per element
   * the last argument can be a callback
   */

  moduleToggler(...toggleObj) {
    const self = this;
    let $el;
    let currentShowObj;
    let len = toggleObj.length - 1;
    let command = typeof toggleObj[0] === 'string' && (toggleObj[0] === 'show' || toggleObj[0].indexOf('hide') !== -1) ? toggleObj[0] : undefined;
    $.fn.toggleAll = function f6(command) {
      $el = $(this);
      const visible = () => {
        return $el.css('visibility') !== 'hidden';
      };
      const displayed = () => {
        return $el.css('display') !== 'none';
      };
      const opaque = () => {
        return $el.css('opacity') !== '0';
      };
      if (displayed() && visible() && !opaque()) {
        $el.css({
          'opacity': '1'
        });
      } else if (displayed() && opaque() && !visible()) {
        $el.css({
          'visibility': 'show'
        });
      } else {
        // eslint-disable-next-line no-lonely-if
        if (command && command.indexOf('hide') !== -1) {
          $el.hide();
          if (command.indexOf('andclear' !== -1)) {
            self.clearInputs($el);
          }
        } else if (command && command === 'show') {
          $el.show();
        } else {
          $el.toggle();
        }
      }
    };
    toggleObj.map((obj, i) => {
      if (typeof obj !== 'function') {
        currentShowObj = obj;
        this.getParentModule(obj).toggleAll(command);
      } else if (i === len) {
        // this is the last argument
        if (obj.Events && typeof obj.Events === 'object' && Object.keys(obj.Events._store).length >= 0) {
          // publish an event saying to hide things and give the module that is being shown
          obj.Events.pub('module-toggler-called', currentShowObj);
        } else {
          obj($el); // perform the callback
        }
      }
    });
  },

  clearInputs($el) {
    const moduleInputs = $el.find(':input');
    moduleInputs.map((i, obj) => {
      // dont remove value of radio buttons just uncheck them
      if (obj.type === 'radio') {
        $(obj).prop('checked', false);
      } else {
        $(obj).val('');
      }
    });
  },
  //

  isJqueryEl(el) {
    // Boolean.  Answers the Q of is this a jQuery element
    // eslint-disable-next-line no-unneeded-ternary
    return 'jquery' in Object(el) ? true : false;
  },
  isPlainArray(el) {
    // Boolean.  Answers the Q of is this a plain array/indexed object
    // eslint-disable-next-line no-unneeded-ternary
    return el && el.constructor === Array && !this.isJqueryEl(el) ? true : false;
  },
  isSpartaModule(el) {
    // Boolean.  Answers the Q of is the selected element a Sparta module
    // eslint-disable-next-line valid-typeof, no-unneeded-ternary
    return this.isJqueryEl(el) && typeof el.attr('data-component') === 'module' ? true : false;
  },
  getParentModule(el) {
    // get parent module element of whatever element you've working with
    if (!this.isSpartaModule(el)) {
      if (!this.isJqueryEl(el)) {
        // eslint-disable-next-line no-param-reassign
        el = $(el);
      }
      // eslint-disable-next-line no-param-reassign
      el = el && el.closest('div[data-component="module"]');
    }
    return el;
  },
  lowerTrimString(key) {
    // e.g. ' Blah Blah YAda' -> 'blahblahyada'
    return key.split(' ').join('').toLowerCase();
  },
  lowerTrimObjectKeys(obj) {
    // turns all object keys into lowercase, trimmed keys.  You're welcome.
    return Object.assign({}, ...Object.keys(obj).map(key => ({
      [this.lowerTrimString(key)]: obj[key]
    })));
  },
  arrayDiff(a, b) {
    // give back an array of the non-matches
    const diffIndexes = [];
    // eslint-disable-next-line prefer-arrow-callback
    return b.filter(function f7(i) {
      if (a.indexOf(i) < 0) {
        diffIndexes.push(b.indexOf(i));
        return true;
        // eslint-disable-next-line no-else-return
      } else {
        return false;
      }
    });
  }
};

export { index as default };
